export const BankAssetUrl = "/images/bank-logo/";

export const Banks = [
  {
    name: "بانک صادرات ایران",
    icon: "BSI",
  },
  {
    name: "بانک ملت",
    icon: "MEL",
  },
  {
    name: "بانک تجارت",
    icon: "TEJ",
  },
  {
    name: "بانک ملی ایران",
    icon: "BMI",
  },
  {
    name: "بانک سپه",
    icon: "BSP",
  },
  {
    name: "بانک کشاورزی",
    icon: "BKV",
  },
  {
    name: "بانک پارسیان",
    icon: "PAR",
    colors: {
      color: "#fff",
      orginal: "rgb(207,138,99)",
      background:
        "linear-gradient(86deg, rgba(207,138,99,1) 0%, rgba(141,72,33,1) 100%)",
    },
  },
  {
    name: "بانک مسکن",
    icon: "BMK",
  },
  {
    name: "بانک رفاه کارگران",
    icon: "REF",
  },
  {
    name: "بانک اقتصاد نوین",
    icon: "ENB",
  },
  {
    name: "بانک انصار",
    icon: "ANS",
  },
  {
    name: "بانک پاسارگاد",
    icon: "PAS",
  },
  {
    name: "بانک سامان",
    icon: "SAM",
  },
  {
    name: "بانک سینا",
    icon: "SIN",
  },
  {
    name: "پست بانک ایران",
    icon: "PST",
  },
  {
    name: "بانک قوامین",
    icon: "GHA",
  },
  {
    name: "بانک توسعه تعاون",
    icon: "BTT",
  },
  {
    name: "بانک شهر",
    icon: "SHR",
  },
  {
    name: "بانک آینده",
    icon: "AYN",
  },
  {
    name: "بانک سرمایه",
    icon: "SAR",
  },
  {
    name: "بانک دی",
    icon: "DEY",
  },
  {
    name: "بانک حکمت ایرانیان",
    icon: "hi",
  },
  {
    name: "بانک ایران زمین",
    icon: "IRZ",
  },
  {
    name: "بانک کارآفرین",
    icon: "BKA",
  },
  {
    name: "بانک گردشگری",
    icon: "GAR",
  },
  {
    name: "بانک صنعت و معدن",
    icon: "BSM",
  },
  {
    name: "بانک توسعه صادرات",
    icon: "edbi",
  },
  {
    name: "بانک خاورمیانه",
    icon: "KHMI",
  },
  {
    name: "بانک رسالت",
    icon: "RES",
  },
  {
    name: "بانک مهر ایران",
    icon: "MHR",
  },
  {
    name: "موسسه اعتباری ملل",
    icon: "ASKC",
  },
  {
    name: "موسسه اعتباری نور",
    icon: "NOR",
  },
  { name: "آسان پرداخت پرشین", icon: "ASAN" },
  { name: "پرداخت الکترونیک پاسارگاد", icon: "PEP" },
  { name: "پرداخت الکترونیک سامان", icon: "SEP" },
  { name: "پرداخت الکترونیک سپهر", icon: "SEPEHR" },
  { name: "پرداخت نوین آرین", icon: "PNA" },
  { name: "ایران کیش", icon: "IKC" },
  { name: "به پرداخت ملت", icon: "BPM" },
  { name: "آسان پرداخت پرشین", icon: "asan" },
  { name: "پرداخت الکترونیک پاسارگاد", icon: "pep" },
  { name: "پرداخت الکترونیک سامان", icon: "sep" },
  { name: "پرداخت الکترونیک سپهر", icon: "sepehr" },
  { name: "پرداخت نوین آرین", icon: "pna" },
  { name: "ایران کیش", icon: "ikc" },
  { name: "به پرداخت ملت", icon: "bpm" },
];
